import axiosInstance from '../../../../config/axiosInstance';
import BASE_URL from '../../../../config/config';
import { HelpLinkValidation } from "../../View/Validation/HelpLinkValidation";

const handleChange = (event, formData, setFormData) => {
  const { name, value } = event.target;
  setFormData({
    ...formData,
    [name]: value,
  });
};

const handleSubmit = async (event, formData, setFormData, setErrors,redirectCallback,redirectRoleList) => {
  debugger;
  event.preventDefault();
  const formErrors = HelpLinkValidation(formData);
  setErrors(formErrors);
  if (Object.keys(formErrors).length === 0) {
    try {
      
      const token = localStorage.getItem('token');
      if (!token || token=="null") {
          redirectCallback();
          return; // Return early to prevent further execution
      }
      
      const UserID=localStorage.getItem("UserID");
      formData.UserID=UserID;
     
      const response = await axiosInstance.post(`/SuperAdmin/CreateHelpLink`, formData);
     
      console.log('Form submitted and data posted:');      
      //setData(responseData);   

      setFormData({
        AssetCategory: '',
        
        // Reset other fields as needed
      });
      redirectRoleList();
    } catch (error) {
      console.error('Error posting data:', error);
    }
  }
};

export { handleChange, handleSubmit };